export default '/src/assets/webgl/pedro_2/audios/outro.mp3'